import { hasCookie } from '../has';

export function removeCookie(key: string, path: string, domain: string) {
	if (!hasCookie(key)) {
		return false;
	}
	const keyStr = encodeURIComponent(key);
	const domainStr = `${domain ? `; domain=${domain}` : ''}`;
	const pathStr = `${path ? `; path=${path}` : ''}`;

	document.cookie = `${keyStr}=; expires=Thu, 01 Jan 1970 00:00:00 GMT${domainStr}${pathStr}`;
	return true;
}
